// extracted by mini-css-extract-plugin
export default {"wrapper":"TutorWebinarRoom_wrapper__dMA+H","streams":"TutorWebinarRoom_streams__s+W5K","chat":"TutorWebinarRoom_chat__tMsQh"};